var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.lpuSite
    ? _c(
        "div",
        {
          staticClass: "d-flex flex-wrap ga-2",
          attrs: { "data-qa": "lpu_page_price_staff_links" },
        },
        _vm._l(_setup.items, function (item) {
          return _c(
            _setup.CorePRG,
            {
              key: item.label,
              attrs: { url: item.url, "button-attrs": { class: "adminka" } },
            },
            [_vm._v("\n    " + _vm._s(item.label) + "\n  ")]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }